import React, { useEffect } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useDispatch, connect } from 'react-redux';
import { resolve } from '../../../utils/object/pathResolver';

const NumberPicker = ({ fields, defaultValue }) => {
  const dispatch = useDispatch();

  const handleChange = modifier => {
    dispatch({
      type: fields.reduxDispatchType?.value,
      payload: defaultValue + modifier,
    });
  };

  useEffect(() => {
    if (fields.reduxDispatchType?.value) {
      dispatch({
        type: fields.reduxDispatchType?.value,
        payload: defaultValue,
      });
    }
  }, []);

  return (
    <div className="vds-d2c-form-page__section">
      <div className="vds-d2c-form-page__inner">
        <div className="vds-form__group vds-form-__group--limited-width">
          <Text
            tag="p"
            className="vds-margin-bottom-spacing-3 vds-margin-right-spacing-5"
            field={fields.intro}
          />
          <div className="vds-input-stepper">
            <button
              className="vds-input-stepper__button vds-input-stepper__button--minus"
              type="button"
              onClick={() => handleChange(-1)}
              disabled={defaultValue === fields.minValue?.value}
              data-testid={`${fields.testid?.value}-decrease`}
            >
              <span className="vds-visually-hidden">Decrease</span>
              <span className="vds-input-stepper__button-icon vds-icon-minus"></span>
            </button>

            <input
              id="stepper-default-1"
              className="vds-form__input vds-input-stepper__input"
              name="stepper-default-1"
              type="text"
              inputMode="decimal"
              value={defaultValue}
              onChange={() => {}}
              data-testid={`${fields.testid?.value}-value`}
            />

            <button
              className="vds-input-stepper__button vds-input-stepper__button--plus"
              type="button"
              onClick={() => handleChange(1)}
              disabled={defaultValue === fields.maxValue?.value}
              data-testid={`${fields.testid?.value}-increase`}
            >
              <span className="vds-visually-hidden">Increase</span>
              <span className="vds-input-stepper__button-icon vds-icon-plus"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    defaultValue = resolve(reduxValuePath, state);
  }
  if (!defaultValue && props.fields.startValue?.value) {
    defaultValue = props.fields.startValue?.value;
  }
  return {
    ...props,
    defaultValue,
  };
};
export default connect(mapStateToProps)(NumberPicker);
